module.exports = __webpack_public_path__ + "img/line_normal@2x.62d03f33.svg";